import { Creators } from './actions';

export const setQuotationsData = Creators.setQuotationsData;
export const reset = Creators.reset;

export default {
  setQuotationsData,
  reset,
};
